<template>
	<div
		v-if="isVisible"
		class="flex flex-col gap-3 px-6 py-4 md:pt-10 md:pb-6"
	>
		<div class="flex flex-col gap-3">
			<div class="flex flex-col text-center md:min-h-[68px]">
				<p class="text-xs font-medium text-won-secondary">
					{{ COACHING_PLAN.label }}
				</p>
				<p class="text-3xl leading-9 font-semibold tracking-tight text-gray-900">
					{{ COACHING_PLAN.title }}
				</p>
				<p class="text-xs text-won-secondary">
					{{ COACHING_PLAN.tagline }}
				</p>
			</div>
			<div class="flex flex-col gap-2">
				<div class="md:min-h-[52px]">
					<button
						type="button"
						class="flex h-9 w-full items-center justify-center rounded-md bg-won-green px-3 text-sm font-medium text-white hover:bg-won-green/90"
						@click="handleBookCallClicked"
					>
						Book Your Free Call
					</button>
				</div>
				<PlanDetailsToggle v-model="detailsOpen" />
			</div>
		</div>

		<div :class="[detailsOpen ? 'flex' : 'hidden md:flex', 'flex-col gap-3']">
			<hr class="border-gray-200" />
			<div class="flex flex-col gap-2">
				<div class="flex flex-col text-xs text-won-secondary">
					<p class="font-medium">
						{{ COACHING_PLAN.introTitle }}
					</p>
					<p>{{ COACHING_PLAN.introBody }}</p>
				</div>
				<ul class="flex flex-col gap-2">
					<li
						v-for="feature of COACHING_PLAN.features"
						:key="feature"
						class="flex items-start gap-1 text-sm text-gray-900"
					>
						<span class="flex h-5 shrink-0 items-center">
							<CheckCircleIcon
								class="size-4 text-won-green"
								aria-hidden="true"
							/>
						</span>
						<span>{{ feature }}</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { CheckCircleIcon } from '@heroicons/vue/24/outline';
import { setAuthState } from '../../../composables/auth';
import { useSubscriptionTrackerStore } from '../../../store/subscription-tracker.store';
import { isSalesGatedLocation } from '../../../utils/locations';
import { CALENDLY_BILLING_URL } from '../../../utils/constants';
import { openLink } from '../../../utils/helpers';
import { COACHING_PLAN } from '../../../constants/pricing-plans';

import PlanDetailsToggle from '../pricing/plan-details-toggle.vue';

const { getUser } = setAuthState();
const subscriptionTrackerStore = useSubscriptionTrackerStore();

const detailsOpen = ref(false);

const isVisible = computed(() => isSalesGatedLocation(getUser()));

const handleBookCallClicked = () => {
	openLink(CALENDLY_BILLING_URL, true);
	subscriptionTrackerStore.handleBookCallClicked();
};
</script>
